export const tunisianCities = [
    { Code: "TUN", EnName: "Tunis" },
    { Code: "SFX", EnName: "Sfax" },
    { Code: "SOS", EnName: "Sousse" },
    { Code: "KRN", EnName: "Kairouan" },
    { Code: "BIZ", EnName: "Bizerte" },
    { Code: "GBS", EnName: "Gabes" },
    { Code: "AM", EnName: "Ariana" },
    { Code: "GFS", EnName: "Gafsa" },
    { Code: "MNS", EnName: "Monastir" },
    { Code: "BA", EnName: "Ben Arous" },
    { Code: "KSR", EnName: "Kasserine" },
    { Code: "MDN", EnName: "Medenine" },
    { Code: "NAB", EnName: "Nabeul" },
    { Code: "TAN", EnName: "Tataouine" },
    { Code: "BJA", EnName: "Beja" },
    { Code: "JDB", EnName: "Jendouba" },
    { Code: "KEF", EnName: "Kef" },
    { Code: "MHD", EnName: "Mahdia" },
    { Code: "SBZ", EnName: "Sidi Bouzid" },
    { Code: "TZR", EnName: "Tozeur" },
    { Code: "SLI", EnName: "Siliana" },
    { Code: "KBL", EnName: "Kebili" },
    { Code: "ZAG", EnName: "Zaghouan" },
    { Code: "MAN", EnName: "Manouba" },
    { Code: "Libya", EnName: "Libya" }
];

export default tunisianCities;